import { withModel } from '../../data-providers/model';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';

import Footer from './Footer';
import withOnTrackLink from '../../hocs/withOnTrackLink';

const enhance = compose(
  withModel,
  mapProps(props => ({
    country: props.model.countryModel,
    columns: props.model.prismicFooterModel.columns,
    socialNetworks: props.model.prismicFooterModel.socialNetworks,
    boringLinks: props.model.prismicFooterModel.boringLinks,
    enableTrustPilot: props.model.prismicFooterModel.enableTrustPilot,
  })),
  withState('activeLinkSetIndex', 'setActiveLinkSetIndex', null),
  withOnTrackLink,
  withHandlers({
    handleToggle: props => index => {
      const value = index === props.activeLinkSetIndex ? null : index;
      props.setActiveLinkSetIndex(value);
    },
  }),
);

export default enhance(Footer);
